import { MAX_CIRCLE_SIZE } from './constants';
import { Circle, Container, CustomSvg, Outer, slideForward } from './style';

interface CircularProgressProps {
  total: number;
  totalCompleted: number;
  children?: React.ReactNode;
}

export function CircularProgress({
  totalCompleted,
  total,
  children,
}: CircularProgressProps) {
  const calcProgress = MAX_CIRCLE_SIZE * (1 - totalCompleted / total);

  return (
    <Container>
      <Outer>{children}</Outer>
      <CustomSvg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="120px"
        height="120px"
        viewBox="0 0 120 120"
      >
        <defs>
          <linearGradient id="gradient-color">
            <stop offset="0%" stopColor="#325A6D" />
            <stop offset="100%" stopColor="#325A6D" />
          </linearGradient>
        </defs>
        <Circle
          cx="60"
          cy="60"
          r={calcProgress === MAX_CIRCLE_SIZE ? 0 : 58}
          style={{
            animation: `${slideForward(
              calcProgress
            )} 600ms ease-in-out forwards`,
          }}
          strokeLinecap="square"
        />
      </CustomSvg>
    </Container>
  );
}
